import { Button } from 'app/components/design-system-components'
import { GTM_MUVAL_DASHBOARD_LEARN_MORE_LINK } from 'app/utils/google-tag-manager/helpers'
import { useGTMTracking } from 'app/utils/hooks/useGTMTracking'

export const MUVAL_SNUG_URL = 'https://get.snug.com/muval/'

function MuvalLink({ textInLink = 'learn more', linkUrl = MUVAL_SNUG_URL }) {
  const {
    trackingProps: { className: trackingClassName, onClick },
  } = useGTMTracking(GTM_MUVAL_DASHBOARD_LEARN_MORE_LINK, linkUrl)

  return (
    <Button variant="linkBlue" className={trackingClassName} onClick={onClick}>
      {textInLink}
    </Button>
  )
}

export default MuvalLink
